import React, { useEffect, useState } from 'react';
import './common.css';
import { FaWrench, FaUsers, FaHandHoldingHeart, FaCheck } from 'react-icons/fa';
import StickyHeader from './StickyHeader';

const Dashboard = () =>{

    return(
        <StickyHeader />
    )
}


export default Dashboard;